import ApiUser from '@/api/User'

// TODO: 3916 Tiers should be fetched dynamically from the backend
const TIERS = [
  { name: 'Select', discount: '15', threshold: '0' },
  { name: 'Premier', discount: '20', threshold: '15000' },
  { name: 'Elite', discount: '25', threshold: '30000' }
]

export const state = () => ({
  userTier: null,
  designerTiers: TIERS,
  annualSpend: 0
})

export const getters = {
  getCurrentTier: state => {
    if (!state.userTier) return null
    return state.designerTiers.find(tier => tier.name === state.userTier)
  },
  getTierByName: state => name => {
    return state.designerTiers.find(tier => tier.name === name)
  },
  getTierDiscount: (_state, getters) => {
    const tier = getters.getCurrentTier
    return tier ? parseFloat(tier.discount) : 0
  },
  getTierColor: (_state, getters) => {
    const tier = getters.getCurrentTier
    return tier ? tier.color : null
  },
  getAnnualSpend: state => {
    return state.annualSpend
  },
  getUserTierName: state => {
    return state.userTier
  },
  getApplicableTier: state => {
    if (!state.annualSpend) return state.designerTiers[0]

    for (let i = state.designerTiers.length - 1; i >= 0; i--) {
      if (state.annualSpend >= parseFloat(state.designerTiers[i].threshold)) {
        return state.designerTiers[i]
      }
    }

    return state.designerTiers[0]
  }
}

export const mutations = {
  setUserTier(state, tierName) {
    state.userTier = tierName
  },
  setAnnualSpend(state, amount) {
    state.annualSpend = parseFloat(amount)
  }
}

export const actions = {
  setUserTier({ commit }, tierName) {
    commit('setUserTier', tierName)
  },
  setAnnualSpend({ commit, dispatch, getters }, amount) {
    commit('setAnnualSpend', amount)

    const applicableTier = getters.getApplicableTier
    dispatch('setUserTier', applicableTier.name)
  },
  async fetchDesignerTier({ dispatch }) {
    try {
      const response = await ApiUser.getDesignerTier(this.$axios)

      if (response.data && response.data.tier_name) {
        dispatch('setUserTier', response.data.tier_name)
        dispatch('setAnnualSpend', response.data.annual_spend)
      }

      return response.data
    } catch (error) {
      console.error('Failed to fetch designer tier:', error)
      throw error
    }
  }
}